export const passportTypes = ['Ordinary', 'Diplomatic', 'Official/Service', 'Laissez-passer','Travel Document'];
export const tourist_visa_slug = 'tourist-visa';
export const diplomatic_visa_slug = 'diplomatic-visa';
export const official_visa_slug = 'official-visa';
export const transit_visa_slug = 'transit-visa';